(function () {
  const root = document.getElementById("summit-singo-app");
  if (!root) return;

  const songsUrl = root.dataset.songsUrl;
  const glossaryUrl = root.dataset.glossaryUrl;

  const tabs = [
    { tab: document.getElementById("tab-play"), panel: document.getElementById("panel-play") },
    { tab: document.getElementById("tab-songs"), panel: document.getElementById("panel-songs") },
    { tab: document.getElementById("tab-glossary"), panel: document.getElementById("panel-glossary") },
  ];

  function selectTab(id) {
    tabs.forEach(({ tab, panel }) => {
      const on = tab.id === id;
      tab.setAttribute("aria-selected", on ? "true" : "false");
      tab.tabIndex = on ? 0 : -1;
      panel.classList.toggle("active", on);
      panel.hidden = !on;
    });
  }

  tabs.forEach(({ tab }) => {
    tab.addEventListener("click", () => selectTab(tab.id));
    tab.addEventListener("keydown", (e) => {
      const i = tabs.findIndex((t) => t.tab === tab);
      if (e.key === "ArrowRight") {
        e.preventDefault();
        tabs[(i + 1) % tabs.length].tab.focus();
      } else if (e.key === "ArrowLeft") {
        e.preventDefault();
        tabs[(i - 1 + tabs.length) % tabs.length].tab.focus();
      } else if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        selectTab(tab.id);
      }
    });
  });

  let allSongs = [];
  let searchTimer = null;
  const MAX_RENDER = 120;

  function escapeHtml(str) {
    return str
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function renderSongs(query) {
    const q = query.trim().toLowerCase();
    const list = document.getElementById("song-results");
    const meta = document.getElementById("song-meta");

    if (!allSongs.length) {
      meta.textContent = "Search unavailable — download the PDF below.";
      list.innerHTML = '<p class="empty">Could not load songs. Try the PDF download.</p>';
      return;
    }

    let matches = allSongs;
    if (q) {
      matches = allSongs.filter(
        (s) => s.title.toLowerCase().includes(q) || s.artist.toLowerCase().includes(q)
      );
    }
    const shown = matches.slice(0, MAX_RENDER);
    meta.textContent = q
      ? `${matches.length.toLocaleString()} match${matches.length === 1 ? "" : "es"}${matches.length > MAX_RENDER ? ` · showing first ${MAX_RENDER}` : ""}`
      : `${allSongs.length.toLocaleString()} songs · type to search`;

    if (!shown.length) {
      list.innerHTML = '<p class="empty">No songs match that search.</p>';
      return;
    }
    list.innerHTML = shown
      .map(
        (s) =>
          `<div class="song-row"><div class="title">${escapeHtml(s.title)}</div><div class="artist">${escapeHtml(s.artist)}</div></div>`
      )
      .join("");
  }

  document.getElementById("song-search").addEventListener("input", (e) => {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(() => renderSongs(e.target.value), 150);
  });

  function renderGlossary(data) {
    document.getElementById("glossary-intro").textContent = data.intro;
    document.getElementById("glossary-list").innerHTML = data.entries
      .map(
        (e) => `
        <article class="glossary-item">
          <h3>${escapeHtml(e.label)}</h3>
          <p>${escapeHtml(e.definition)}</p>
          <ul class="examples">${e.examples.map((x) => `<li>${escapeHtml(x)}</li>`).join("")}</ul>
        </article>`
      )
      .join("");
  }

  async function loadData() {
    const glossaryPromise = fetch(glossaryUrl)
      .then((res) => res.json())
      .then(renderGlossary)
      .catch(() => {
        document.getElementById("glossary-intro").textContent =
          "Glossary unavailable — ask a host!";
      });

    try {
      const songsRes = await fetch(songsUrl);
      const songsData = await songsRes.json();
      allSongs = songsData.songs || [];
      renderSongs("");
    } catch {
      allSongs = [];
      renderSongs("");
    }

    await glossaryPromise;
  }

  loadData();
})();
